import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { animeSeries } from '@/mocks/anime';
import AnimeCard from '@/components/feature/AnimeCard';

const filters = ['全部', '奇幻', '治愈', '武侠', '科幻', '校园', '悬疑'];

export default function SeriesGrid() {
  const [params] = useSearchParams();
  const urlQuery = (params.get('q') ?? '').toLowerCase();
  const [category, setCategory] = useState('全部');

  const filtered = useMemo(() => {
    return animeSeries.filter((a) => {
      const matchCat = category === '全部' || a.genre.includes(category);
      const matchQuery =
        !urlQuery || a.title.toLowerCase().includes(urlQuery) || a.tagline.toLowerCase().includes(urlQuery);
      return matchCat && matchQuery;
    });
  }, [category, urlQuery]);

  return (
    <section id="series" className="scroll-mt-16 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-secondary-600">
            <i className="ri-stack-fill" /> 作品库
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {urlQuery ? `“${urlQuery}” 的搜索结果` : '全部作品'}
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-700 md:text-base">
            {urlQuery
              ? `为你找到 ${filtered.length} 部相关作品的分集剧情`
              : '每部作品都配有完整的每话简介与剧情梳理，按分类筛选想看的类型。'}
          </p>
        </div>

        {/* category tabs */}
        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setCategory(f)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                category === f
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-800 hover:bg-background-200'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        {filtered.length > 0 ? (
          <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
            {filtered.map((anime) => (
              <AnimeCard key={anime.slug} anime={anime} />
            ))}
          </div>
        ) : (
          <div className="mt-10 flex flex-col items-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-search-line text-4xl text-foreground-400" />
            <p className="text-sm font-medium text-foreground-800">没有找到相关作品</p>
            <p className="text-sm text-foreground-600">换个关键词试试，或浏览下面的热门分类。</p>
          </div>
        )}
      </div>
    </section>
  );
}